module.exports = __webpack_public_path__ + "img/animals_06_V.a3a22e16.webp";